import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  texto_uno: z.string().min(1, 'El texto 1 es obligatorio'),
  texto_dos: z.string().min(1, 'El texto 2 es obligatorio'),
  imagen: z.string().min(1, 'La imagen es obligatoria'),
  esDetalle: z.boolean(),
  detalle: z.string().optional(),
  sucursales: z.object({
    value: z.string().min(1, 'La sucursal es obligatoria'),
    label: z.string()
  }, {
    required_error: 'La sucursal es obligatoria',
    invalid_type_error: 'La sucursal es obligatoria',
  }),
}).superRefine((data, ctx) => {
  console.log("data",data);
  if (data.esDetalle && (!data.detalle || data.detalle.trim() === '')) {
    ctx.addIssue({
      path: ['detalle'],
      code: z.ZodIssueCode.custom,
      message: 'El detalle es obligatorio',
    });
  }
});
